var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.currentPage !== 'c-shop' )?_c('v-btn',{staticClass:"blue--text ",attrs:{"text":""},on:{"click":function($event){return _vm.navigateTo('c-shop')}}},[_vm._v(" "+_vm._s(_vm.$t('ManageStoreButtonText'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }